<template>
  <div class="row">
    <!--  积分记录列表  -->
    <div class="flex xs12">
      <va-card title="积分记录">
        <div class="row">
          <div class="flex md9 sm6 xs12">
            <va-button-group>
              <va-button class="mb-2" disabled flat color="gray">业务类型：</va-button>
              <va-button class="mb-2" flat :color="computeSelectedEventTypeColor(null)" v-on:click="handleEventTypeChange(null)" >全部</va-button>
              <va-button
                class="mb-2"
                flat
                v-for="eventType in eventTypes"
                :key="eventType.CODE"
                :color="computeSelectedEventTypeColor(eventType.CODE)"
                v-on:click="handleEventTypeChange(eventType.CODE)" >{{eventType.TEXT}}</va-button>
            </va-button-group>

            <va-button-group>
              <va-button class="mb-2" disabled flat color="gray">操作类型：</va-button>
              <va-button class="mb-2" flat :color="computeSelectedOpTypeColor(null)" v-on:click="handleOpTypeChange(null)" >全部</va-button>
              <va-button
                class="mb-2"
                flat
                v-for="opType in opTypes"
                :key="opType.CODE"
                :color="computeSelectedOpTypeColor(opType.CODE)"
                v-on:click="handleOpTypeChange(opType.CODE)" >{{opType.TEXT}}</va-button>
            </va-button-group>

            <va-button-group>
              <va-button class="mb-2" disabled flat color="gray">货币类型：</va-button>
              <va-button class="mb-2" flat :color="computeSelectedVmTypeColor(null)" v-on:click="handleVmTypeChange(null)" >全部</va-button>
              <va-button
                class="mb-2"
                flat
                v-for="vmType in vmTypes"
                :key="vmType.CODE"
                :color="computeSelectedVmTypeColor(vmType.CODE)"
                v-on:click="handleVmTypeChange(vmType.CODE)" >{{vmType.TEXT}}</va-button>
              <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
            </va-button-group>
          </div>

          <div class="flex md4 xs12 sm6">
            <va-input
              class="ma-0"
              :value="uid"
              placeholder="搜索学员uid"
              @input="searchUid"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <!--          <div class="flex md4 xs12 sm6">-->
          <!--            <va-input-->
          <!--              class="ma-0"-->
          <!--              :value="recordId"-->
          <!--              placeholder="搜索流水号"-->
          <!--              @input="searchRecordId"-->
          <!--              removable-->
          <!--            >-->
          <!--              <va-icon name="fa fa-search" slot="prepend"/>-->
          <!--            </va-input>-->
          <!--          </div>-->

          <div class="flex md8 xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="info" small outline @click="assignPointsModal=true" v-show="isSuperManager">分配积分</va-button>
            </div>
          </div>
        </div>

        <va-data-table
          :fields="fields"
          :data="virtualMoneyRecords"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listVirtualMoneyRecord"
          api-mode
        >
          <template slot="nickname" slot-scope="props">
            <va-button color="gray" flat small :to='{path:`/admin/users/updateUser/${props.rowData.uid}`}' :disabled="!props.rowData.uid">
              {{ props.rowData.nickname }}
            </va-button>
          </template>
          <template slot="eventType" slot-scope="props">
            <va-button flat small color="black" disabled>
              {{ computeEventType(props.rowData.eventType).text }}
            </va-button>
          </template>
          <template slot="opType" slot-scope="props">
            <va-button flat small color="black"  disabled>
              {{ `${computeOpType(props.rowData.opType).text === '增加' ? '+' : '-'}${props.rowData.count}` }}
            </va-button>
          </template>
          <template slot="vmType" slot-scope="props">
            <va-button flat small color="black" disabled>
              {{ computeVmType(props.rowData.vmType).text }}
            </va-button>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="查看" placement="top">
              <va-button flat small color="gray" icon="fa fa-eye"
                :to='{path:`getVirtualMoneyRecord/${props.rowData.recordId}`}'/>
            </va-popover>
          </template>
        </va-data-table>
        <va-modal v-model="assignPointsModal" title="分配积分"
          okText="提交" position="center" message="请选择"
          @ok="confirmAssignPoints">
          <va-select
            v-model="insertData.uid"
            label="用户"
            :options="userOptions"
            searchable
            width="350px"
            :messages="message"
            :error="!!error.userErrors.length"
            :error-messages="error.userErrors"
          />
          <va-select
            v-model="insertData.opType"
            label="加/减"
            :options="opTypeOptions"
            width="350px"
            :messages="message"
            :error="!!error.opTypeErrors.length"
            :error-messages="error.opTypeErrors"
          />
          <va-select
            v-model="insertData.vmType"
            label="货币类型"
            :options="vmTypeOptions"
            width="350px"
            :messages="message"
            :error="!!error.vmTypeErrors.length"
            :error-messages="error.vmTypeErrors"
          />
          <va-input
            v-model="insertData.count"
            label="数值"
            placeholder="数字越大越靠前"
            removable
            type="number"
            :min="1"
            oninput="if(value<1)value=1"
            :messages="message"
            :error="!!error.countErrors.length"
            :error-messages="error.countErrors"
          />
        </va-modal>
      </va-card>
    </div>
  </div>
</template>

<script>

import { EVENT_TYPES, OP_TYPES, VM_TYPES } from '@/utils/constants'
import { computeEventType, computeOpType, computeVmType, formatTime } from '@/utils/common'
import virtualMoneyApi from '@/api/virtualMoney'
import debounce from 'lodash/debounce'
import employeeApi from '@/api/employee'
import userApi from '@/api/user'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      uid: '',
      nickname: '',
      eventType: null,
      recordId: null,
      vmType: null,
      opType: null,
      tagType: null,
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      totalPages: 1,
      totalCount: 0,
      eventTypes: EVENT_TYPES,
      opTypes: OP_TYPES,
      vmTypes: VM_TYPES,
      virtualMoneyRecords: [],
      isSuperManager: false,
      assignPointsModal: false,
      users: [],
      insertData: {
        uid: '',
        vmType: null,
        opType: null,
        count: 0,
      },
      userOptions: [],
      opTypeOptions: OP_TYPES.map(x => x.TEXT),
      vmTypeOptions: VM_TYPES.map(x => x.TEXT),
      error: {
        opTypeErrors: [],
        vmTypeErrors: [],
        userErrors: [],
        countErrors: [],
      },
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'recordId',
          title: '流水号',
          width: '15%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:nickname',
          title: '用户昵称',
          width: '15%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:eventType',
          title: '业务类型',
          width: '15%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:opType',
          title: '货币数',
          width: '15%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:vmType',
          title: '货币类型',
          width: '15%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '15%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '10%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
    formReady () {
      return !this.error.opTypeErrors.length &&
          !this.error.vmTypeErrors.length &&
          !this.error.countErrors.length &&
          !this.error.userErrors.length
    },

  },
  created () {
    this.initParams()
    this.listVirtualMoneyRecord()
    this.initButton()
    this.listUser()
  },
  methods: {
    computedUser () {
      const res = {}
      this.users.forEach(x => {
        res[x.nickname + '(' + x.uid + ')'] = x.uid
      })
      return res
    },
    initButton () {
      const id = localStorage.getItem('employeeId')
      employeeApi.listEmployeePermissions(id).then(response => {
        response.permissions.forEach(x => {
          if (x.action === 'super_admin_access') {
            this.isSuperManager = true
          }
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    initParams () {
      this.uid = this.$route.query.uid
    },
    listVirtualMoneyRecord (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageNumber: pageNumber,
        pageSize: this.pageSize,
        eventType: this.eventType,
        opType: this.opType,
        uid: this.uid,
        vmType: this.vmType,
        recordId: this.recordId,
      }
      virtualMoneyApi.listVirtualMoneyRecord(params).then(response => {
        this.virtualMoneyRecords = response.virtualMoneyRecords
        this.virtualMoneyRecords.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    searchRecordId: debounce(function (recordId) {
      this.recordId = recordId
      this.listVirtualMoneyRecord(1)
    }, 400),
    searchUid: debounce(function (uid) {
      this.uid = uid
      this.listVirtualMoneyRecord(1)
    }, 400),

    computeEventType (eventType) {
      return computeEventType(eventType)
    },
    computeOpType (opType) {
      return computeOpType(opType)
    },
    computeVmType (vmType) {
      return computeVmType(vmType)
    },
    computeSelectedEventTypeColor (eventType) {
      return eventType === this.eventType ? 'info' : 'gray'
    },
    handleEventTypeChange (eventType) {
      this.eventType = eventType
      this.pageNumber = 1
      this.listVirtualMoneyRecord()
    },
    computeSelectedOpTypeColor (opType) {
      return opType === this.opType ? 'info' : 'gray'
    },
    handleOpTypeChange (opType) {
      this.opType = opType
      this.pageNumber = 1
      this.listVirtualMoneyRecord()
    },
    computeSelectedVmTypeColor (vmType) {
      return vmType === this.vmType ? 'info' : 'gray'
    },
    handleVmTypeChange (opType) {
      this.opType = opType
      this.pageNumber = 1
      this.listVirtualMoneyRecord()
    },
    listUser () {
      this.userOptions = []
      const params = {
        pageNumber: 1,
        pageSize: 10000,
      }
      userApi.listUser(params).then(response => {
        this.users = response.users
        response.users.forEach(x => {
          this.userOptions.push(x.nickname + '(' + x.uid + ')')
        })
      })
    },
    confirmAssignPoints () {
      this.checkField()
      if (!this.formReady) {
        this.showToast('请补全未填写的字段', {
          duration: 3000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      const data = {
        uid: this.computedUser()[this.insertData.uid],
        count: this.insertData.count,
        eventType: 0,
      }
      this.opTypes.forEach(x => {
        if (x.TEXT === this.insertData.opType) {
          data.opType = x.CODE
        }
      })
      this.vmTypes.forEach(x => {
        if (x.TEXT === this.insertData.vmType) {
          data.vmType = x.CODE
        }
      })
      virtualMoneyApi.updateUserVirtualMoney(data.uid, data).then(response => {
        if (response.success === true) {
          this.showToast(`分配成功，当前用户积分为${response.points}`, {
            duration: 1000,
            icon: 'fa-success',
            position: 'top-center',
            fullWidth: false,
          })
          this.listVirtualMoneyRecord()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    checkField () {
      this.error.userErrors = this.insertData.uid ? [] : ['uid is required']
      this.error.countErrors = this.insertData.count ? [] : ['count is required']
      this.error.opTypeErrors = this.insertData.opType ? [] : ['opType is required']
      this.error.vmTypeErrors = this.insertData.vmType ? [] : ['vmType is required']
    },

  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
